import CommonTextArea from 'common/components/entities/TextArea'
import { TextAreaInterface } from 'common/types/entities/TextAreaInterface'
import React from 'react'
import BaseEntityNew from '../../../components/core/BaseEntity/BaseEntityNew'
import { EntityProps } from '../../../types'
import { useContactUsDescendantIds } from './ContactUs'

function TextArea({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<TextAreaInterface>) {
  const entityIds = useContactUsDescendantIds()
  return (
    <BaseEntityNew
      entity={entity}
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
      isRemoveAllowed={false}
      isSaveAllowed={false}
      isCopyAllowed={false}
      dropBoxAllowedEntityIds={entityIds}
    >
      <CommonTextArea
        fontSize={entity.fontSize}
        mobileFontSize={entity.mobileFontSize}
        placeholder={entity.placeholder}
        padding={entity.padding}
        mobilePadding={entity.mobilePadding}
        height={entity.height}
        id={entity.htmlAttrId}
        border={entity.border}
        mobileBorder={entity.mobileBorder}
        backgroundColor={entity.backgroundColor}
        mobileBackgroundColor={entity.mobileBackgroundColor}
        boxShadow={entity.boxShadow}
        mobileBoxShadow={entity.mobileBoxShadow}
        color={entity.color}
        mobileColor={entity.mobileColor}
      />
    </BaseEntityNew>
  )
}

export default TextArea
